;(function () {
  angular.module('contrast.filters').filter('truncate', function () {
    return function (value, characterLimit) {
      if (!value) {
        return ''
      }

      return value.length < characterLimit
        ? value
        : value.substring(0, characterLimit / 2) +
            ' \n ... \n ' +
            value.substring(value.length - characterLimit / 2, value.length)
    }
  })
})()
